<template>
  <main class="agenda_accordion" :class="!showMenu ? 'agenda_accordion--hidden' : ''">
    <div>
      <span class="toggle" @click="showMenu =! showMenu">
        <div class="toggle__wrapper">
          <i class="icon icon-arrow-left" />
          <i class="icon icon-arrow-left" />
        </div>
      </span>
      <div class="content">
        <transition-group name="fade_down">
          <article v-for="cat of categories" :key="cat.label">
            <h2 class="d-flex">
              <dr-icon :name="cat.icon" fill="blue" style="width: 15px"></dr-icon> &ensp;
              <transition name="fade" mode="out-in">
                <big v-if="loading" class="loading">&emsp;</big>
                <big v-else>{{cat.total}}</big>
              </transition>
              &nbsp;
              {{ cat.label }}{{ (cat.total > 1 || cat.total === 0 || loading) ? 's' : '' }}
            </h2>
            <hr />
            <transition name="fade">
              <ul v-if="!loading">
                <transition-group name="fade_down">

                  <template v-if="cat.label === 'Atendimento'">
                    <template v-for="(group, $groupIndex) in cat.data">
                      <li
                        v-for="(item, $index) in group"
                        :key="$index + item.label"
                      >
                        <big><strong>{{item.count}}</strong></big>

                        {{item.label}}
                      </li>

                      <hr :key="$groupIndex" />
                    </template>
                  </template>

                  <template v-else>
                    <li v-for="(item, $index) in cat.data" :key="$index + item.label"><big><strong>{{item.count}}</strong></big> {{item.label}}</li>
                  </template>

                </transition-group>
              </ul>
            </transition>
          </article>
        </transition-group>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      default () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    getCategories () {
      return this.categories
    }
  }
}
</script>
